import React from 'react'
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Card,
  IconButton,
  Switch,
} from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import DeleteIcon from '@material-ui/icons/DeleteOutlined'
import AddIcon from '@material-ui/icons/Add'
import { SecaoGenerica, CustomButton } from 'components'
import { cutMaxLength } from 'utils/helpers'

const maxLength50 = (newValue) => cutMaxLength(newValue, 50)
const maxLength250 = (newValue) => cutMaxLength(newValue, 250)
const maxLength8000 = (newValue) => cutMaxLength(newValue, 8000)

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  limit: 100,
})

export const FormCaracteristicasVestigio = (props) => {
  const {
    route,
    values,
    touched,
    errors,
    handleChange,
    handleChangeWithModification,
    handleChangeTipoVestigioGenerica,
    handleChangeNewValueByNameProperty,
    caracteristicasVestigio,
    adicionarCaracteristica,
    removerCaracteristica,
    atualizarCaracteristica,
    tiposVestigios,
    opcoesTiposVestigiosEspecificosAtual,
    classes,
    useState,
    lacreAtualHabilitado,
  } = props

  const [lacreInicialHabilitado, setLacreInicialHabilitado] = useState(false)

  if (route.editar) {
    return (
      <SecaoGenerica titulo="Características do Vestígio" spacing={3}>
        <Grid item xs={12} sm={4} md={2}>
          <TextField
            variant="outlined"
            label="UNIDADES"
            required
            fullWidth
            value={values.quantidade}
            InputLabelProps={{
              shrink: true,
            }}
            name="quantidade"
            onChange={(e) => {
              const input = e.target.value
              const regex = /^[1-9]\d*$/
              if (regex.test(input) || input === '') {
                handleChange(e)
              }
            }}
            error={touched.quantidade && !!errors.quantidade}
            helperText={touched.quantidade && errors.quantidade ? errors.quantidade : null}
          />
        </Grid>

        <Grid item xs={12} sm={8} md={4}>
          <TextField
            variant="outlined"
            label="LACRE ATUAL"
            required={lacreAtualHabilitado}
            disabled={!lacreAtualHabilitado}
            fullWidth
            value={values.lacre}
            InputLabelProps={{
              shrink: true,
            }} 
            name="lacre"
            onChange={(e) => handleChangeWithModification(e, maxLength50)}
            error={touched.lacre && !!errors.lacre}
            helperText={touched.lacre && errors.lacre ? errors.lacre : null}
          />
          <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
            Caracteres restantes: {50 - (values.lacre?.length || 0)}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={8} md={3}>
          <TextField
            variant="outlined"
            label="LACRE INICIAL - INFORMADO NO CADASTRO"
            required={lacreInicialHabilitado}
            disabled={!lacreInicialHabilitado}
            fullWidth
            value={values.lacreAcondicionamento}
            InputLabelProps={{
              shrink: true,
            }}
            name="lacreAcondicionamento"
            onChange={(e) => handleChangeWithModification(e, maxLength50)}
            error={lacreInicialHabilitado && touched.lacreAcondicionamento && !!errors.lacreAcondicionamento}
            helperText={lacreInicialHabilitado && touched.lacreAcondicionamento && errors.lacreAcondicionamento ? errors.lacreAcondicionamento : null}
          />
          <FormControlLabel
            control={
              <Switch
                checked={lacreInicialHabilitado}
                onChange={(e) => setLacreInicialHabilitado(e.target.checked)}
                color="primary"
              />
            }
            label="Permitir alteração do lacre inicial"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
          <TextField
            variant="outlined"
            label="NÚMERO DE VESTÍGIO ASSOCIADO"
            fullWidth
            value={values.numeroVestigioAssociado}
            InputLabelProps={{
              shrink: true,
            }}
            name="numeroVestigioAssociado"
            onChange={(e) => handleChangeWithModification(e, maxLength250)}
          />
          <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
            Caracteres restantes: {250 - (values.numeroVestigioAssociado?.length || 0)}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.embalagemContainer}>
            <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
              TIPO DA EMBALAGEM
            </Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="tipo-embalagem"
                name="tipoEmbalagem"
                value={values.tipoEmbalagem || null}
                onChange={handleChange}
                className={classes.radioGroupHorizontal}
              >
                <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
              </RadioGroup>
            </FormControl>
            {values.tipoEmbalagem === 'OUTRO' && (
              <Grid item xs={12} style={{ marginTop: '16px' }}>
                <TextField
                  label="OUTRO TIPO DE EMBALAGEM"
                  name="outroTipoEmbalagem"
                  variant="outlined"
                  value={values.outroTipoEmbalagem || ''}
                  onChange={(e) => handleChangeWithModification(e, maxLength250)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
                  Caracteres restantes: {250 - (values.outroTipoEmbalagem?.length || 0)}
                </Typography>
              </Grid>
            )}
          </div>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            value={values.tiposGens || []}
            name="tiposGens"
            multiple
            filterOptions={filterOptions}
            noOptionsText="Sem informações"
            options={tiposVestigios || []}
            onChange={(event, newValue) => handleChangeTipoVestigioGenerica(event, newValue)}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.nome?.toUpperCase() || ''}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={!values.tiposGens?.length ? 'Selecionar...' : null}
                label="NATUREZA PRELIMINAR DO VESTÍGIO (GENÉRICA)"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                error={touched.tiposGens && !!errors.tiposGens}
                helperText={touched.tiposGens && errors.tiposGens ? errors.tiposGens : null}
              />
            )}
            className={classes.tipoVestigio}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            value={values.tiposEsps || []}
            name="tiposEsps"
            multiple
            filterOptions={filterOptions}
            noOptionsText="Sem informações"
            options={opcoesTiposVestigiosEspecificosAtual || []}
            onChange={(event, newValue) => handleChangeNewValueByNameProperty('tiposEsps', newValue)}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.nome?.toUpperCase() || ''}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={!values.tiposEsps?.length ? 'Selecionar...' : null}
                label="NATUREZA PRELIMINAR DO VESTÍGIO (ESPECÍFICA)"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                error={touched.tiposEsps && !!errors.tiposEsps}
                helperText={touched.tiposEsps && errors.tiposEsps ? errors.tiposEsps : null}
              />
            )}
            className={classes.tipoVestigio}
          />
        </Grid>

        {values.tiposEsps?.some((tipoEspecifico) => tipoEspecifico.identificador === 'OBJETO') && (
          <Grid item xs={12}>
            <div className={classes.embalagemContainer}>
              <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
                TAMANHO DO OBJETO
              </Typography>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  aria-label="tamanhoObjeto"
                  name="tamanhoObjeto"
                  value={values.tamanhoObjeto || null}
                  onChange={handleChange}
                  className={classes.radioGroupHorizontal}
                >
                  <FormControlLabel value="PEQUENO" control={<Radio />} label={<Typography variant="body2">PEQUENO</Typography>} />
                  <FormControlLabel value="MEDIO" control={<Radio />} label={<Typography variant="body2">MÉDIO</Typography>} />
                  <FormControlLabel value="GRANDE" control={<Radio />} label={<Typography variant="body2">GRANDE</Typography>} />
                </RadioGroup>
              </FormControl>
            </div>
          </Grid>
        )}

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            label="DESCRIÇÃO"
            multiline
            minRows={5}
            required
            fullWidth
            value={values.descricao || ''}
            InputLabelProps={{
              shrink: true,
            }}
            name="descricao"
            onChange={(e) => handleChangeWithModification(e, maxLength8000)}
            error={touched.descricao && !!errors.descricao}
            helperText={touched.descricao && errors.descricao ? errors.descricao : null}
          />
          <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
            Caracteres restantes: {8000 - (values.descricao?.length || 0)}
          </Typography>
        </Grid>
      </SecaoGenerica>
    )
  }

  // Se for rota de cadastro, renderiza lista de vestígios a serem adicionados dinamicamente
  return (
    <SecaoGenerica titulo="Vestígios a serem Adicionados" spacing={3}>
      <Grid item xs={12}>
        {caracteristicasVestigio.map((caracteristica, index) => (
          <Card key={index} className={classes.cardNovoVestigio}>
            {/* Cabeçalho do Card Estilizado */}
            <div className={classes.cardHeader}>
              <Typography variant="subtitle1" color="inherit" style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                Vestígio #{index + 1}
              </Typography>
              {caracteristicasVestigio.length > 1 && (
                <IconButton size="small" onClick={() => removerCaracteristica(index)} title="Remover Vestígio" style={{ color: 'inherit' }}>
                  <DeleteIcon color="error" />
                </IconButton>
              )}
            </div>

            {/* Corpo do Card com Grid Simétrico */}
            <div className={classes.cardBody}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4} md={2}>
                  <TextField
                    variant="outlined"
                    label="UNIDADES"
                    required
                    fullWidth
                    value={caracteristica.quantidade}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="quantidade"
                    onChange={(e) => {
                      const input = e.target.value
                      const regex = /^[1-9]\d*$/
                      if (regex.test(input) || input === '') {
                        atualizarCaracteristica(index, 'quantidade', e.target.value)
                      }
                    }}
                    error={!caracteristica.quantidade}
                    helperText={!caracteristica.quantidade ? 'campo obrigatório' : null}
                  />
                </Grid>

                <Grid item xs={12} sm={8} md={5}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="NÚMERO DO LACRE"
                    required
                    value={caracteristica.lacre || ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="lacre"
                    onChange={(e) => atualizarCaracteristica(index, 'lacre', e.target.value)}
                    error={!caracteristica.lacre}
                    helperText={!caracteristica.lacre ? 'campo obrigatório' : null}
                  />
                  <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
                    Caracteres restantes: {50 - (caracteristica.lacre?.length || 0)}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={5}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="NÚMERO DE VESTÍGIO ASSOCIADO"
                    value={caracteristica.numeroVestigioAssociado || ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="numeroVestigioAssociado"
                    onChange={(e) => atualizarCaracteristica(index, 'numeroVestigioAssociado', e.target.value)}
                  />
                  <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
                    Caracteres restantes: {50 - (caracteristica.numeroVestigioAssociado?.length || 0)}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <div className={classes.embalagemContainer}>
                    <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
                      TIPO DA EMBALAGEM
                    </Typography>
                    <FormControl component="fieldset" fullWidth>
                      <RadioGroup
                        aria-label="tipo-embalagem"
                        name="tipoEmbalagem"
                        value={caracteristica.tipoEmbalagem || null}
                        onChange={(e) => atualizarCaracteristica(index, 'tipoEmbalagem', e.target.value)}
                        className={classes.radioGroupHorizontal}
                      >
                        <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                        <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                        <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                        <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                        <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                        <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
                      </RadioGroup>
                    </FormControl>
                    {caracteristica.tipoEmbalagem === 'OUTRO' && (
                      <Grid item xs={12} style={{ marginTop: '16px' }}>
                        <TextField
                          label="OUTRO TIPO DE EMBALAGEM"
                          name="outroTipoEmbalagem"
                          variant="outlined"
                          value={caracteristica.outroTipoEmbalagem || ''}
                          onChange={(e) => atualizarCaracteristica(index, 'outroTipoEmbalagem', e.target.value)}
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
                          Caracteres restantes: {250 - (caracteristica.outroTipoEmbalagem?.length || 0)}
                        </Typography>
                      </Grid>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={caracteristica.tiposGens || []}
                    name="tiposGens"
                    multiple
                    filterOptions={filterOptions}
                    noOptionsText="Sem informações"
                    options={tiposVestigios || []}
                    onChange={(event, newValue) => atualizarCaracteristica(index, 'tiposGens', newValue)}
                    getOptionSelected={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.nome?.toUpperCase() || ''}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={!caracteristica.tiposGens?.length ? 'Selecionar...' : null}
                        label="NATUREZA PRELIMINAR DO VESTÍGIO (GENÉRICA)"
                        required
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={!caracteristica.tiposGens?.length}
                        helperText={!caracteristica.tiposGens?.length ? 'campo obrigatório' : null}
                      />
                    )}
                    className={classes.tipoVestigio}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    value={caracteristica.tiposEsps || []}
                    name="tiposEsps"
                    multiple
                    filterOptions={filterOptions}
                    noOptionsText="Sem informações"
                    options={caracteristica.opcoesTiposVestigiosEspecificos || []}
                    onChange={(event, newValue) => atualizarCaracteristica(index, 'tiposEsps', newValue)}
                    getOptionSelected={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.nome?.toUpperCase() || ''}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={!caracteristica.tiposEsps?.length ? 'Selecionar...' : null}
                        label="NATUREZA PRELIMINAR DO VESTÍGIO (ESPECÍFICA)"
                        required
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={!caracteristica.tiposEsps?.length}
                        helperText={!caracteristica.tiposEsps?.length ? 'campo obrigatório' : null}
                      />
                    )}
                    className={classes.tipoVestigio}
                  />
                </Grid>

                {caracteristica.tiposEsps?.some((tipoEspecifico) => tipoEspecifico.identificador === 'OBJETO') && (
                  <Grid item xs={12}>
                    <div className={classes.embalagemContainer}>
                      <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '12px' }}>
                        TAMANHO DO OBJETO
                      </Typography>
                      <FormControl component="fieldset" fullWidth>
                        <RadioGroup
                          aria-label="tamanhoObjeto"
                          name="tamanhoObjeto"
                          value={caracteristica.tamanhoObjeto || null}
                          onChange={(event, val) => atualizarCaracteristica(index, 'tamanhoObjeto', val)}
                          className={classes.radioGroupHorizontal}
                        >
                          <FormControlLabel value="PEQUENO" control={<Radio />} label={<Typography variant="body2">PEQUENO</Typography>} />
                          <FormControlLabel value="MEDIO" control={<Radio />} label={<Typography variant="body2">MÉDIO</Typography>} />
                          <FormControlLabel value="GRANDE" control={<Radio />} label={<Typography variant="body2">GRANDE</Typography>} />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label="DESCRIÇÃO"
                    multiline
                    minRows={5}
                    required
                    fullWidth
                    value={caracteristica.descricao || ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="descricao"
                    onChange={(e) => atualizarCaracteristica(index, 'descricao', e.target.value)}
                    error={!caracteristica.descricao?.length}
                    helperText={!caracteristica.descricao?.length ? 'campo obrigatório' : null}
                  />
                  <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
                    Caracteres restantes: {8000 - (caracteristica.descricao?.length || 0)}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Card>
        ))}
      </Grid>

      <Grid item container justifyContent="flex-end" xs={12} style={{ marginTop: '8px' }}>
        <CustomButton
          colorType="secondary"
          variant="contained"
          onClick={adicionarCaracteristica}
          startIcon={<AddIcon />}
        >
          Adicionar vestígio
        </CustomButton>
      </Grid>
    </SecaoGenerica>
  )
}
